export default __webpack_public_path__ + "static/media/LoveNovel.81dc8ae4.png";